module.exports = __webpack_public_path__ + "static/media/IconAddFileOneByOne.4acfbfb0.svg";